interface SelectOptions {
  value: number
  label: string
}

export const generateSelectOptions = (
  min: number,
  max: number
): SelectOptions[] => {
  const options: SelectOptions[] = []
  for (let i = min; i <= max; i++) {
    const label = i > 0 ? `+${i}` : `${i}`
    options.push({ value: i, label: label })
  }
  return options
}
